@if (activeQuestion() && hasPlayableMedia$()) {
  <div [formGroup]="activeQuestion()" class="media-settings">
    <div class="media-settings__title fs__lg fw__500">Media</div>

    <div class="media-settings__input-containers">
      <div class="media-settings__require-completion">
        <mat-slide-toggle
          class="border"
          [labelPosition]="'before'"
          [color]="'primary'"
          formControlName="requireMediaCompletionInd"
          [checked]="activeQuestion().value.requireMediaCompletionInd"
        >
          Disable ‘Next’ until the media has finished playing
        </mat-slide-toggle>
      </div>

      <div class="media-settings__auto-play">
        <mat-slide-toggle color="primary" labelPosition="before" formControlName="autoplayMediaInd" [checked]="activeQuestion().value.autoplayMediaInd">
          Autoplay media on page load
          @if (hasMultiplePlayableMedia$()) {
            <fa-icon [icon]="faInfoCircle" size="lg" matTooltip="Only the first media you upload will play automatically."></fa-icon>
          }
        </mat-slide-toggle>
      </div>
    </div>
  </div>
}
